import type { ColumnDefWithPermissions } from "@/lib/hooks/useTable/useTableColumns";

/**
 * Column definition creator — single column.
 *
 * Thin typed wrapper over ColumnDefWithPermissions. The `header` should use the
 * standard TanStack function form to access the column instance:
 *
 * ```tsx
 * const clientColumn = createColumn<VenteCommande>({
 *   id: "client",
 *   header: ({ column }) => <DataTableColumnHeader column={column} title="Client" />,
 *   accessorFn: (row) => row.client?.raisonSociale ?? "—",
 *   size: 200,
 * });
 * ```
 */
export function createColumn<TData>(
  column: ColumnDefWithPermissions<TData>,
): ColumnDefWithPermissions<TData> {
  return column;
}

/**
 * Batch column definition creator — array of columns.
 *
 * ```tsx
 * export const commandesColumns = createColumns<VenteCommande>([
 *   numeroColumn,
 *   clientColumn,
 *   dateCommandeColumn,
 * ]);
 * ```
 */
export function createColumns<TData>(
  columns: ColumnDefWithPermissions<TData>[],
): ColumnDefWithPermissions<TData>[] {
  return columns;
}

// ──────────────────────────── Re-exports ────────────────────────────

export type { ColumnDefWithPermissions } from "@/lib/hooks/useTable/useTableColumns";
